import React from 'react';
import { withTranslation } from 'react-i18next';
import CurrencyRangeFilter from '../../../components/Filters/CurrencyRangeFilter';
import { FilterProps } from './FilterProps';

export type AmountFilterProps = FilterProps

const AmountFilter = (
    {
        queryParams,
        t,
        onChange,
    }: AmountFilterProps
) => {
    const min = queryParams.get('amount.gte');
    const max = queryParams.get('amount.lte');
    const values =
        min || max
            ? {
                min: min || '',
                max: max || '',
            }
            : undefined;

    return (
        <CurrencyRangeFilter
            name="amount"
            currency="NOK"
            title={t('payments.filter.amount.title')}
            onApply={(min, max) => {
                onChange({
                    'amount.gte': min ? [min] : [],
                    'amount.lte': max ? [max] : [],
                });
            }}
            onDelete={_ => {
                onChange({
                    'amount.gte': [],
                    'amount.lte': [],
                });
            }}
            values={values}
        />
    );
};

export default withTranslation()(AmountFilter);
